import React, { useCallback, useRef, useState } from 'react';
import { Item } from '../styles';
export default (function (_a) {
    var Name = _a.name, children = _a.children, _b = _a.defaultOpen, defaultOpen = _b === void 0 ? false : _b;
    var _c = useState(defaultOpen), isOpen = _c[0], setOpen = _c[1];
    var contentRef = useRef(null);
    var onClick = useCallback(function () {
        setOpen(!isOpen);
        var content = contentRef.current;
        if (content && content.style)
            if (content.style.maxHeight) {
                content.style.maxHeight = '';
            }
            else {
                content.style.maxHeight = "".concat(content.scrollHeight, "px");
            }
    }, [contentRef, isOpen]);
    return (React.createElement(React.Fragment, null,
        React.createElement(Item, null,
            React.createElement(Name, { isOpen: isOpen, onClick: onClick, className: "collapsible" }),
            React.createElement("div", { className: "content", ref: contentRef }, children))));
});
